import { Record } from 'immutable';

export default Record({
  token: '',
  account_id: '',
  account_name: '',
  owner_name: '',
  user_id: ''
});



// WEBPACK FOOTER //
// ./src/feathers/session-record.js